import SlideCard from "./SlideCard";

const SliderHome = () => {
  const imgHome = [
    // "./images/slide/bg0.jpg",
    "./images/slide/bg1.jpg",
    "./images/slide/bg2.jpg",
    "./images/slide/bg3.jpg",
    "./images/slide/bg4.jpg",
  ];
  return (
    <section className="mb-5">
      <div>
        <SlideCard imgRender={imgHome} />
      </div>
    </section>
  );
};

export default SliderHome;
